import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { RealtimeActions } from "./store/realtime.actions";
import { realtimeFeature } from "./store/realtime.reducer";

@Injectable({ providedIn: "root" })
export class RealtimeRoomFacade {
    private readonly store = inject(Store);

    readonly currentRoom = this.store.selectSignal(realtimeFeature.selectCurrentRoom);
    readonly status = this.store.selectSignal(realtimeFeature.selectRoomStatus);

    createOrJoin(room: string | null = null): void {
        this.store.dispatch(RealtimeActions.createOrJoinRoomRequested({ room }));
    }

    returnToPersonalRoom(): void {
        this.createOrJoin(null);
    }
}
